/**
 * Labels for the Wallet card history (AuditLogPanel, module "wallet"). Mirrors the API's
 * src/const/marketing.js entity/action names and the walletPassConfig keys.
 */
export const WALLET_AUDIT_ENTITIES = {
  offerMessage: "wallet_offer_message",
  locationAlerts: "wallet_location_alerts",
  design: "wallet_design",
  refreshAll: "wallet_refresh_all",
};

export const WALLET_AUDIT_ACTION_LABELS = {
  update: "Settings changed",
  push_all: "Pushed to all wallets",
};

export const WALLET_AUDIT_FIELD_LABELS = {
  // offer
  text: "Text (EN)",
  textAr: "Text (AR)",
  // location alerts
  enabled: "Near-branch suggestion",
  maxDistanceM: "Max distance (m)",
  branchMode: "Branch selection",
  branchIds: "Selected branches",
  branchTexts: "Per-branch texts",
  // design
  backgroundColor: "Pass background",
  foregroundColor: "Text colour",
  labelColor: "Label colour",
  stripPrimaryColor: "Stamp / accent colour",
  emptyTileColor: "Empty tile colour",
  stampFillOpacity: "Stamp tile opacity",
  emptyTileOpacity: "Empty tile opacity",
  stripOverlayColor: "Overlay tint",
  stripOverlayOpacity: "Overlay opacity",
  stampRows: "Rows",
  stampRowGap: "Row gap",
  stampColGap: "Column gap",
  stampPadTop: "Padding top",
  stampPadBottom: "Padding bottom",
  stampIconScale: "Icon size",
  showLogo: "Show logo",
  showLogoText: "Show title text",
  headerRightText: "Top-right text",
  walletPassIcon: "Pass icon",
  walletPassStrip: "Strip image",
  walletPassStampFilledIcon: "Filled stamp icon",
  walletPassStampEmptyIcon: "Empty stamp icon",
  walletPassStripBackground: "Strip background",
  // push metadata
  kind: "Kind",
  passes: "Passes updated",
  devices: "Devices",
  sent: "Sent",
  failed: "Failed",
  pruned: "Dead devices removed",
  pushed: "Pushed",
  reason: "Result",
  offerText: "Offer (EN)",
  offerTextAr: "Offer (AR)",
};

/** Human wording for the push metadata values. */
export const walletAuditResolve = (field, value) => {
  if (field === "kind") return value === "offer" ? "Offer announcement (notifies card holders)" : "Silent refresh";
  if (field === "reason") {
    return {
      no_passes: "no passes yet",
      no_devices: "no devices registered",
      apns_unavailable: "APNs not configured — devices refresh on next sync",
      error: "failed",
    }[value] ?? (value === null || value === undefined ? "sent" : String(value));
  }
  if (field === "branchMode") return value === "manual" ? "Manual (fixed list)" : "Automatic (customer's most-visited)";
  if (field === "branchIds" && Array.isArray(value)) return value.length ? `${value.length} branch${value.length === 1 ? "" : "es"} (${value.join(", ")})` : "none";
  if (field === "branchTexts" && value && typeof value === "object") {
    const n = Object.keys(value).length;
    return n ? `${n} branch override${n === 1 ? "" : "s"}` : "none";
  }
  return undefined;
};
